<div class="flex h-full flex-col text-gray-700">
  <dl class="flex flex-col gap-2 pt-3">
    <div
      class="flex items-center justify-between rounded-md border-t border-l-2 border-gray-100 bg-gray-50 px-3 py-3.5 text-gray-700"
      [ngClass]="{
        'border-l-iq-monitor': category === 'warning',
        'border-l-iq-investigate': category === 'critical',
        'border-l-iq-observe': category !== 'warning' && category !== 'critical',
      }"
      [attr.aria-label]="'Latency: ' + latency + 'ms, severity: ' + severityLabel"
    >
      <dt class="font-lato text-base">Latency:</dt>
      <dd class="font-lato text-base font-semibold">{{ latency }}<span class="ml-0.5 text-sm font-normal">ms</span></dd>
    </div>

    <div
      class="flex items-center justify-between rounded-md border-t border-l-2 border-gray-100 bg-gray-50 px-3 py-3.5 text-gray-700"
      [ngClass]="{
        'border-l-iq-monitor': category === 'warning',
        'border-l-iq-investigate': category === 'critical',
        'border-l-iq-observe': category !== 'warning' && category !== 'critical',
      }"
      [attr.aria-label]="'Jitter: ' + jitter + 'ms, severity: ' + severityLabel"
    >
      <dt class="font-lato text-base">Jitter:</dt>
      <dd class="font-lato text-base font-semibold">{{ jitter }}<span class="ml-0.5 text-sm font-normal">ms</span></dd>
    </div>

    <div
      class="flex items-center justify-between rounded-md border-t border-l-2 border-gray-100 bg-gray-50 px-3 py-3.5 text-gray-700"
      [ngClass]="{
        'border-l-iq-monitor': category === 'warning',
        'border-l-iq-investigate': category === 'critical',
        'border-l-iq-observe': category !== 'warning' && category !== 'critical',
      }"
      [attr.aria-label]="'Packet Loss: ' + packetLost + '%, severity: ' + severityLabel"
    >
      <dt class="font-lato text-base">Packet Loss:</dt>
      <dd class="font-lato text-base font-semibold">{{ packetLost }}<span class="ml-0.5 text-sm font-normal">%</span></dd>
    </div>
  </dl>
</div>
